import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

import Colors from "../../Constant/Colors";
import CustomText from "../Text";
import { OutlinedButton, Icon } from "./styles";

const IconButton = ({
  icon,
  text,
  style,
  textStyle,
  onClick,
  iconStyle,
  disabled,
  loading,
  onKeyDown,
  tabIndex
}) => {
  return (
    <OutlinedButton
      style={style}
      onClick={!disabled ? onClick : null}
      disabled={disabled}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}  // Directly pass the event
    >
      {icon && (
        <Icon
          src={icon}
          style={{ height: 20, width: 20, marginRight: 10, ...iconStyle }}
        />
      )}
      {loading ? (
        <ClipLoader color={"white"} size={20} />
      ) : (
        <CustomText
          style={{
            color: Colors.whiteThemeColor,
            fontWeight: "700",
            ...textStyle,
          }}
          text={text}
        />
      )}
    </OutlinedButton>
  );
};


export default IconButton;
